// import { IAdminData } from "./../../interfaces/admin.interface";
// import { IHttp, IHttpResponse } from "./../../interfaces/http.interface";
import axiosInstance from "../../axios/axios";
import { AxiosResponse } from "axios";
import CustomerInfoDto from "./dtos/CustomerInfoDto";
import QueryResponse from "./shared models/QueryResponse";
import { CustomerAddressDto } from "./dtos/CustomerAddressDto";
import { requestHeader } from "./sharedUtils";
import { PagedResponseDto } from "./shared models/PagedResponseDto";
import { CustomerDto } from "./dtos/CustomerDto";

export const listAllCustomers = async (
  data: any
): Promise<[QueryResponse<PagedResponseDto<CustomerDto>> | null, unknown]> => {
  try {
    const response = await axiosInstance.get<
      QueryResponse<PagedResponseDto<CustomerDto>>
    >(
      `/customer/list?PageNumber=${data.pageIndex}&PageSize=${data.pageSize}&OrderBy=${data.OrderBy}&Search=${data.Search}`,
      requestHeader
    );
    return [response.data, null];
  } catch (err) {
    return [null, err];
  }
};

export const getAllCustomers = async (): Promise<
  [QueryResponse<CustomerDto[]> | null, unknown]
> => {
  try {
    const response = await axiosInstance.get<QueryResponse<CustomerDto[]>>(
      `/customer/all`,
      requestHeader
    );
    return [response.data, null];
  } catch (err) {
    return [null, err];
  }
};

export const addNewAdmin = async (data: any) => {
  try {
    const response = await axiosInstance.post(
      "/admin/add",
      data,
      requestHeader
    );
    return [response.data, null];
  } catch (err) {
    return [null, err];
  }
};

export const registerByAdmin = async (data: any) => {
  try {
    const response = await axiosInstance.post(
      "/customer/registerbyadmin",
      data,
      requestHeader
    );
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};

export const editCustomer = async (data: any) => {
  try {
    const response = await axiosInstance.put(
      "/customer/updatefromadmin",
      data,
      requestHeader
    );
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};

export const changeCustomerPassword = async (data: any) => {
  try {
    const response = await axiosInstance.post(
      "/customer/resetpasswordbyadmin",
      data,
      requestHeader
    );
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};

export const customerAccountSetting = async (data: any) => {
  try {
    const response = await axiosInstance.put("/customer", data, requestHeader);
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};

export const deleteCustomer = async (id: any) => {
  try {
    const response = await axiosInstance.delete(
      `/customer/${id}`,
      requestHeader
    );
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};

export const getCustomerInfo = async (
  id: any
): Promise<[AxiosResponse<QueryResponse<CustomerInfoDto>> | null, unknown]> => {
  try {
    const response = await axiosInstance.get<QueryResponse<CustomerInfoDto>>(
      `/auth/me`,
      requestHeader
    );
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};

export const getpdf = async () => {
  try {
    const response = await axiosInstance.get(
      `/pricingpdf/current`,
      requestHeader
    );
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};

export const getCustomerAddresses = async (): Promise<
  [QueryResponse<CustomerAddressDto[]> | null, unknown]
> => {
  try {
    const response = await axiosInstance.get<
      QueryResponse<CustomerAddressDto[]>
    >(`/myaddresses`, requestHeader);
    return [response.data, null];
  } catch (err) {
    return [null, err];
  }
};
